import Marionette from 'backbone.marionette';
import billDetailVoteCompositvewTmpl from '../templates/bill_detail_vote_compositview.tpl';
import billDetailVoteItemview from './bill_detail_vote_itemview';
export default Marionette.CompositeView.extend({
  template: billDetailVoteCompositvewTmpl,
  childView: billDetailVoteItemview,
  tagName: "table",
  className: "table table-hover table-sm",
  childViewContainer: "tbody"
});